import { Component } from "~/src/internals/Component";

export class Mobile extends Component {}
